<template>
  <b-navbar toggleable="lg" type="light" variant="light"
  class="shadow-sm p-3 mb-5 bg-white rounded">
    <b-navbar-brand center id="logo">
      <router-link to="/"><img alt="Logo" src="../assets/logo.png"></router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
     <b-collapse id="nav-collapse" is-nav>
    <b-navbar-nav>
    <b-nav-item to="/">{{ translate.main }}</b-nav-item>
    <b-nav-item to="/about">{{ translate.about }}</b-nav-item>
    <b-nav-item :href="translate.url">{{ translate.contact }}</b-nav-item>
    <b-nav-item href="http://fishrpc.kz">{{ translate.general }}</b-nav-item>
    </b-navbar-nav>
    </b-collapse>
      <LocaleSwitcher class="fishNavbar" />
  </b-navbar>
</template>

<script>
import LocaleSwitcher from './LocaleSwitcher.vue';

export default {
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },

  },
  data() {
    return {
      kz: {
        main: 'Бастысы',
        about: 'Біз жайлы',
        contact: 'Байланыстар',
        general: 'Басты сайтқа оралу',
        url: 'http://fishrpc.kz/%d0%b1%d0%b0%d0%b9%d0%bb%d0%b0%d0%bd%d1%8b%d1%81/?lang=kz',
      },
      ru: {
        main: 'Главная',
        about: 'О нас',
        contact: 'Контакты',
        general: 'Вернуться на главный сайт',
        url: 'http://fishrpc.kz/%d0%ba%d0%be%d0%bd%d1%82%d0%b0%d0%ba%d1%82%d1%8b/?lang=ru',
      },
    };
  },
  components: {
    LocaleSwitcher,
  },
};
</script>


<style scoped>
    .navbar {
        background-color: #fff;
        padding:0 !important;
    }
    .country-icon {
        width: 20px;
        height: auto;
        display: inline-block;
        vertical-align: baseline;
        border: 1px solid #dee2e6;
        box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
    }

    .country-icon.as-toggle {
        margin-top: 5px;
    }

    .locale-name {
        display: inline-block;
        vertical-align: baseline;
    }
#logo {
  padding-left:50px;
}

li {
    list-style-type: none;
}
#logo .agrar {
  height:86px;
}
#logo .kz {
  height:86px;
}

.fishNavbar {
  background: #22a6de;
  padding-left: 428px;
  padding-right: 85px;
  padding-top:27px;
  padding-bottom:27px;
  clip-path: polygon(29% 0,100% 0%,100% 250%,0% 250%);
  -webkit-mask-clip: inherit;
}

#nav a {
  font-weight: bold;
  color: #356e4c !important;
}

#nav a.router-link-exact-active {
  color: #356e4c !important;
}

@media (max-width: 979px) {
 .fishNavbar {
  background: #fff;
  padding-left: 0;
  padding-right: 0;
  padding-top:0;
  padding-bottom:0;
  clip-path:none;
  -webkit-mask-clip:unset;
}
#localSwitcher .nav-item.b-nav-dropdown.dropdown a.dropdown-toggle {
   color: #356e4c;
 }

    .navbar {
        background-color: #fff;
        padding:0 !important;
    }
    .country-icon {
        width: 20px;
        height: auto;
        display: inline-block;
        vertical-align: baseline;
        border: 1px solid #dee2e6;
        box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
    }

    .country-icon.as-toggle {
        margin-top: 5px;
    }

    .locale-name {
        display: inline-block;
        vertical-align: baseline;
    }
#logo {
  padding-left:50px;
}

li {
    list-style-type: none;
}
#logo .agrar {
  height:86px;
}
#logo .kz {
  height:86px;
}

    a {
      color: #356e4c;
    }
    a:hover {
      color: #356e4c;
    }
    }

        a {
      color: #356e4c;
    }
    a:hover {
      color: #356e4c;
    }
</style>
